import { RootState } from '../../types/store';
import { Dialog } from 'chayns-api';

export const selectDialogs = (state: RootState): Array<Dialog> => state.dialogs.data;
